import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TokenService } from '@services/token-service';
import { RouterOutlet } from '@angular/router';
import { OverlaysComponent } from './components/overlays/overlays.component';

@Component({
  selector: 'lv-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, OverlaysComponent]
})
export class AppComponent {
  private tokenService = inject(TokenService);
  private translateService = inject(TranslateService);

  constructor() {
    this.tokenService.init();
    const locale = new URLSearchParams(document.location.search).get('locale');
    if (locale) {
      this.translateService.use(locale);
    }
  }
}
